import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatSidenav, MatExpansionPanel } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { SecurityService } from '../../security/security.service';
import { SidenavComunicationService } from './sidenav-comunication.service';
import { ScrollComunicationService } from '../../shared-services/scroll-comunication.service';
import { MediaService } from '../../shared-services/media.service';
import { BackendService } from '../../core/backend.service';
import { Role } from '../../security/role/role.model';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {

  user: any;
  title: string;
  avatarURL: string;
  year: number;
  subscriptions: Subscription[] = [];
  userCanEnterCanvass: boolean;
  userCanEnterOrganization: boolean;
  userCanEnterTerritory: boolean;
  rol:Role;

  @ViewChild('sidenav') sidenav: MatSidenav;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: SecurityService,
    private securityService: SecurityService,
    private sidenavComunicationService: SidenavComunicationService,
    private scrollComunicationService: ScrollComunicationService,
    private mediaService: MediaService,
    private backendService: BackendService
  ) {
    this.year = new Date().getFullYear();
    this.router.events.subscribe(event => {
      if (event) {
        document.title = 'Viacotone Backoffice';
        this.route.snapshot.children.forEach(r => {
          if (r.data.title) {
            this.title = r.data.title;
          }
        });
        document.title += this.title ? ' - ' + this.title : '';
      }
    });
  }

  logout() { this.authService.logout(); }

  closePanels(...panels: MatExpansionPanel[]) {
    panels.forEach(p => p.close());
  }

  async ngOnInit() {
    this.user = this.authService.user;
    this.userCanEnterCanvass = true;
    this.userCanEnterOrganization = true;
    this.userCanEnterTerritory = true;

    this.subscriptions.push(this.sidenavComunicationService.onGetSidenavStatus.subscribe(() => {
      this.updateSideNavStatus();
    }));

    this.subscriptions.push(
      this.mediaService.isMobile.subscribe(isMobile => {
        this.closeSidenav();

        this.sidenav.mode = isMobile ? 'over' : 'side';

        if (!isMobile) {
          setTimeout(() => { this.openSidenav(); }, 500);
        }
      })
    );

    this.subscriptions.push();

    this.backendService.get(Role,"/new-roles/user/"+this.user.id).toPromise().then(a =>{
      this.rol = a;
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onScroll(event: any) {
    this.scrollComunicationService.scroll(event);
  }

  updateSideNavStatus() {
    this.sidenavComunicationService.sidenavChange(this.sidenav.opened);
  }

  toggleSidenav() {
    this.sidenav.toggle();

    if (this.sidenav.mode === 'side') {
      this.updateSideNavStatus();
    }
  }

  openSidenav() {
    this.sidenav.open();

    if (this.sidenav.mode === 'side') {
      this.updateSideNavStatus();
    }
  }

  closeSidenav() {
    this.sidenav.close();

    if (this.sidenav.mode === 'side') {
      this.updateSideNavStatus();
    }
  }

  closeOverSidenav() {
    if (this.sidenav.mode === 'over') {
      this.sidenav.close();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/layout/layout.component.ts